import { render, staticRenderFns } from "./TemplateAllList.vue?vue&type=template&id=264d21de&scoped=true&xmlns%3Ael-col=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml&"
import script from "./TemplateAllList.vue?vue&type=script&lang=js&"
export * from "./TemplateAllList.vue?vue&type=script&lang=js&"
import style0 from "./TemplateAllList.vue?vue&type=style&index=0&id=264d21de&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264d21de",
  null
  
)

export default component.exports